import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Grid, FormControl, Typography, TextField, Divider } from '@material-ui/core';
import { inputFieldStyles, commonInlineStyles } from '../../styles';

const DocumentFetchDetailsSection = forwardRef(
  (
    {
      initialData = {},
      editMode = false,
      onChange,
    },
    ref
  ) => {
    const [data, setData] = useState({ ...initialData });
    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
      setData({ ...initialData });
      setErrors({});
      setSubmitted(false);
    }, [initialData]);

    useImperativeHandle(ref, () => ({
      getFormData: () => data,
      getPayload: () => ({
        updateDocumentFetchDetails: true,
        vendorPlantDetails: {
          siteNameFromReport: data.siteNameFromReport || '',
        },
      }),
      validateForm: () => {
        if (!data.siteNameFromReport || data.siteNameFromReport.trim() === '') {
          setErrors({ siteNameFromReport: 'This field is required.' });
          setSubmitted(true);
          return false;
        }
        setErrors({});
        return true;
      },
      resetForm: () => {
        setData({ ...initialData });
        setErrors({});
        setSubmitted(false);
      },
    }));

    const handleChange = (e) => {
      const { name, value } = e.target;
      setData((prev) => ({ ...prev, [name]: value }));
      if (onChange) onChange({ ...data, [name]: value }, true);
      if (errors[name]) {
        setErrors((prev) => ({ ...prev, [name]: '' }));
      }
    };

    return (
      <div className="cmo-stepper-wrapper shipment-config-step">
        <div className="stepper-container">
          <form>
            <Grid className="two-col-forms-grid" container spacing={3}>
              <Grid item xs={12} sm={6}>
                <FormControl style={{ width: '100%' }}>
                  <Typography component="label" htmlFor="siteNameFromReport">
                    CMO Site Value In The CMO Reports {editMode && <span style={{ color: "red" }}>*</span>}
                  </Typography>
                  {!editMode ? (
                    <Typography>{data?.siteNameFromReport || 'N/A'}</Typography>
                  ) : (
                    <TextField
                      id="siteNameFromReport"
                      name="siteNameFromReport"
                      value={data.siteNameFromReport || ''}
                      onChange={handleChange}
                      onBlur={(e) => {
                        const { name, value } = e.target;
                        // Trim leading and trailing spaces for string values
                        if (typeof value === "string" && value.trim() !== value) {
                          handleChange({ target: { name, value: value.trim() } });
                        }
                      }}
                      variant="outlined"
                      placeholder="Enter text here"
                      fullWidth
                      required
                      error={submitted && Boolean(errors?.siteNameFromReport)}
                      helperText={submitted && errors?.siteNameFromReport ? errors.siteNameFromReport : ''}
                      InputProps={{ style: commonInlineStyles.input }}
                      sx={inputFieldStyles}
                      inputProps={{ ...commonInlineStyles.inputProps }}
                      style={commonInlineStyles.input}
                      onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^a-zA-Z0-9\s&.,\-/]/g, "")
                        .replace(
                          /(\s{2,}|&{2,}|,-{2,}|,{2,}|\.{2,}|\/{2,}|'{2,}|\({2,}|\){2,})/g,
                          (match) => match[0]
                        );
                    }}
                    />
                  )}
                </FormControl>
              </Grid>
            </Grid>
          </form>
          <Divider style={{ margin: "80px 00px 0px 00px", backgroundColor: '#707070', height: 1, }} />
        </div>
      </div>
    );
  }
);

export default DocumentFetchDetailsSection; 